module.exports = require('../../module.compiled').vendored[
  'contexts'
].ServerInsertedHtml
